import { createContext, useContext } from 'react';

import type { HelpTopicId } from '@/shared/lib/help-topics';

/**
 * Where a contextual "?" gets the short text of a Help Center article. The Help Center feature
 * fills it in (`HelpTipProvider`), so the text of an article stays in ONE place and is only
 * downloaded when a tip is first shown. Without a provider (tests, isolated components) only the
 * tips that bring their own `text` have anything to say.
 */
export interface HelpTipSource {
  /** The short explanation of an article in the current language, once it is loaded. */
  tip: (id: HelpTopicId) => string | undefined;
  /** Start downloading the guide text (idempotent). Called when a tip is first shown. */
  request: () => void;
}

export const HelpTipSourceContext = createContext<HelpTipSource | null>(null);

export function useHelpTipSource(): HelpTipSource | null {
  return useContext(HelpTipSourceContext);
}
